import { useQuery, useMutation } from '@tanstack/react-query'
import {
  fetchForgotPasswordApi,
  verifyOtpApi,
  resendOtpApi,
  changePasswordApi,
  resetPasswordApi,
  logoutApi,
  deleteApi,
  updateEmailApi,
  verifyOtpUpdateEmailApi,
  verifySignUP,
  updateMobileApi,
  verifyOtpUpdateMobileApi,
  verifyPasswordApi
} from '../api/loginApi'
import { QUERY_KEY } from '../utils/constants'
import { logoutAccount } from '../api/logoutApi'

// export const useForgotPassword = (params = {}, options = {}) => {
//   return useQuery({
//     queryKey: [
//       'GET_FORGOT_PASSWORD',
//       params.email,
//       params.calling_code,
//       params.mobile
//     ],
//     queryFn: async () => {
//       const resp = await fetchForgotPasswordApi(
//         params.email,
//         params.calling_code,
//         params.mobile
//       )
//       return resp
//     },
//     enabled: false,
//     ...options
//   })
// }

export const useForgotPassword = (options = {}) => {
  return useMutation({
    mutationFn: ({ email, calling_code, mobile }) =>
      fetchForgotPasswordApi(email, calling_code, mobile),
    ...options
  })
}

export const useVerifyOtp = (options = {}) => {
  return useMutation({
    mutationKey: ['VERIFY_OTP'],
    mutationFn: async (formData) => {
      const resp = await verifyOtpApi(formData)
      return resp
    },
    ...options
  })
}

export const useResendOtp = (options = {}) => {
  return useMutation({
    mutationKey: ['RESEND_OTP'],
    mutationFn: async ({ email, calling_code, mobile, intent }) => {
      const resp = await resendOtpApi(email, mobile, calling_code, intent)
      return resp
    },
    ...options
  })
}

export const useChangePassword = (options = {}) => {
  return useMutation({
    mutationKey: ['CHANGE_PASSWORD'],
    mutationFn: async ({
      new_password,
      new_password_confirm,
      old_password
    }) => {
      const payload = {
        new_password,
        new_password_confirm
      }
      
      // Only include old_password if provided
      if (old_password) {
        payload.old_password = old_password
      }
      
      const resp = await changePasswordApi(payload)
      return resp
    },
    ...options
  })
}

export const useResetPassword = (options = {}) => {
  return useMutation({
    mutationKey: ['RESET_PASSWORD'],
    mutationFn: async ({ email, new_password,confirm_password, calling_code, mobile }) => {
      const resp = await resetPasswordApi(
        email,
        new_password,
        confirm_password,
        calling_code,
        mobile
      )
      return resp
    },
    ...options
  })
}

export const useLogout = (options = {}) => {
  return useMutation({
    mutationKey: [QUERY_KEY.LOGOUT],
    mutationFn: async () => {
      const resp = await logoutAccount()
      return resp
    },
    ...options
  })
}

export const useDeleteAccount = (options = {}) => {
  return useMutation({
    mutationKey: [QUERY_KEY.DeleteAccount],
    mutationFn: async () => {
      const resp = await deleteApi()
      return resp
    },
    ...options
  })
}

export const useUpdateEmail = (options = {}) => {
  return useMutation({
    mutationKey: ['UPDATE_EMAIL'],
    mutationFn: async (email) => {
      const resp = await updateEmailApi(email)
      return resp
    },
    ...options
  })
}

export const useUpdateMobile = (options = {}) => {
  return useMutation({
    mutationKey: ['UPDATE_MOBILE'],
    mutationFn: async ({ mobile, calling_code ,intent}) => {
      const resp = await updateMobileApi(mobile, calling_code, intent)
      return resp
    },
    ...options
  })
}

export const useVerifyOtpUpdateEmail = (options = {}) => {
  return useMutation({
    mutationKey: ['VERIFY_OTP_UPDATE_EMAIL'],
    mutationFn: async ({ email, otp, intent }) => {
      const resp = await verifyOtpUpdateEmailApi(email, otp, intent)
      return resp
    },
    ...options
  })
}

export const useVerifyOtpUpdateMobile = (options = {}) => {
  return useMutation({
    mutationKey: ['VERIFY_OTP_UPDATE_MOBILE'],
    mutationFn: async ({ mobile, calling_code, otp, intent }) => {
      const resp = await verifyOtpUpdateMobileApi(mobile, calling_code, otp, intent)
      return resp
    },
    ...options
  })
}

export const useVerifySignUp = (options = {}) => {
  return useMutation({
    mutationKey: ['VERIFY_SIGNUP'],
    mutationFn: async () => {
      const resp = await verifySignUP()
      return resp
    },
    ...options
  })
}

export const useVerifyPassword = (options = {}) => {
  return useMutation({
    mutationKey: ['VERIFY_PASSWORD'],
    mutationFn: async ({ password, intent }) => {
      const resp = await verifyPasswordApi({ password, intent })
      return resp
    },
    ...options
  })
}
